import React, { Fragment } from 'react';
import { Skeleton, Stack } from '@mui/material';

export const StagesSkeleton = () => (
  <Stack gap="1rem">
    <Stack direction="row" alignContent="center" justifyContent="space-between">
      <Stack direction="row" gap="0.5rem" alignItems="center">
        <Skeleton variant="text" sx={{ width: '100px', height: '36px' }} />

        {new Array(5).fill('').map((_, i, arr) => (
          <Fragment key={i}>
            <Skeleton variant="rectangular" sx={{ width: '120px', height: '32px' }} />
          </Fragment>
        ))}
      </Stack>

      <Stack direction="row" gap="0.5rem">
        <Skeleton variant="rectangular" sx={{ width: '100px', height: '36px' }} />
        <Skeleton variant="rectangular" sx={{ width: '30px', height: '36px' }} />
      </Stack>
    </Stack>
  </Stack>
);
